import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const SiteSettingsContext = createContext({});

export const useSiteSettings = () => useContext(SiteSettingsContext);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const fetchSettings = useCallback(async () => {
    try {
      const res = await api.get('/site-settings/');
      setSettings(res.data);
    } catch {
      // silently fail — use defaults
    }
  }, []);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  // Update favicon dynamically
  useEffect(() => {
    if (!settings?.favicon) return;
    const link = document.querySelector("link[rel~='icon']");
    if (link) link.href = settings.favicon;
    const apple = document.querySelector("link[rel='apple-touch-icon']");
    if (apple) apple.href = settings.favicon;
  }, [settings?.favicon]);

  return (
    <SiteSettingsContext.Provider value={{ settings, refreshSettings: fetchSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}
